import { createAction, props } from '@ngrx/store';
import * as Types from '../modals';

export const CheckoutOrderBegin = createAction('[CheckoutI] Begin', props<{ payload: object, replaceUrl: boolean }>());
export const CheckoutOrderUpdate = createAction('[CheckoutI] Update', props<{ checkout: Types.CheckoutI }>());
